import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [persistedState()],
  //储存
  state: {
    i: '',
    Authorization: '',
    uid: '',
    accountNumber: '',
    password: '',
    userName: '',
    jurisdiction: '',
    member: '',
    toPath: '',
    userInfo: {
      name: ''
    },
    upUrl: '',
    avatarUrl: '',
  },
  mutations: {
    //给上传链接赋值
    setUpUrl (state) {
      if (process.env.NODE_ENV == 'production') {
        state.avatarUrl = 'https://www.tuanyun99.com/wxoms/app/index.php?i=' + state.i + '&c=entry&do=pro&m=wxl_oms&op=avatar'
        state.upUrl = 'https://www.tuanyun99.com/wxoms/app/index.php?i=' + state.i + '&c=entry&do=upfile&m=wxl_oms&op=upload'
      } else if (process.env.NODE_ENV == 'development') {
        state.upUrl = '/api/index.php?i=' + state.i + '&c=entry&do=upfile&m=wxl_oms&op=upload'
        state.avatarUrl = '/api/index.php?i=' + state.i + '&c=entry&do=pro&m=wxl_oms&op=avatar'
      }


    },
    //给公众号的id赋值
    setI (state, data) {
      state.i = data
    },
    //添加用户基本信息
    upUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    // 添加用户权限列表
    upMember (state, member) {
      state.member = member
    },
    //添加url
    upToPath (state, toPath) {
      state.toPath = toPath
    },
    //添加tok
    upAuthorization (state, data) {
      state.Authorization = data
    },
    // 添加用户名
    upName (state, userName) {
      state.userName = userName
    },
    //添加账号与密码
    upAccount (state, accountNumber) {
      state.accountNumber = accountNumber
    },
    upPassWord (state, password) {
      state.password = password
    },
    //添加uid
    upUid (state, data) {
      state.uid = data
      console.log(state);
    },
    // 添加用户权限
    upJurisdiction (state, data) {
      state.jurisdiction = data
    },

    // 清空数据
    removerData (state) {
      for (const key in state) {

        if (key == 'userInfo') {
          state.userInfo = {

          }
        } else if (key != 'accountNumber' || key != 'password') {
          state[key] = null
        }
      }
    },
    //清除账号与密码
    reAccount (state) {
      state.accountNumber = ''
      state.password = ''
    },


  },
  actions: {

  },
  getters: {

  },
  modules: {
  }
})
